import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';
import appendQueryString from '../utils/appendQueryString';
import useSharedApps from '../../../utils/sitecoreContext/useSharedApps';
import { BUILD_AND_PRICE_URL } from '../../../utils/constants';
import { selectAllTransmissionsFromVehicles } from '../../../core/reducers/vehicles';
import { selectIsLayoutServiceSkipped, selectLayoutServiceHasError, selectLayoutServiceIsTriggered, } from '../../../core/reducers/ui';
import { useAppSelector } from '../../../core/utils';
import { usePageEditing, usePageState } from '../../../utils/sitecoreContext';
const useBapParamsValidation = (redirectToSummary, redirectData) => {
    const transformedData = {};
    Object.keys(redirectData).forEach(key => {
        const value = redirectData[key];
        transformedData[key] = String(value);
    });
    const baseUrl = useSharedApps(BUILD_AND_PRICE_URL);
    const transmissions = useAppSelector(selectAllTransmissionsFromVehicles);
    const layoutIsSkipped = useAppSelector(selectIsLayoutServiceSkipped);
    const layoutHasError = useAppSelector(selectLayoutServiceHasError);
    const layoutIsTriggered = useAppSelector(selectLayoutServiceIsTriggered);
    const { backStepUrl } = useAppSelector(state => state.ui.TrimOverview);
    const { search, pathname } = useLocation();
    const query = useMemo(() => new URLSearchParams(search), [search]);
    const modelQueryParams = ['modelKey', 'modelYear'];
    const queryModelKey = query.get('modelKey');
    const queryModelYear = query.get('modelYear');
    const queryTrimKey = query.get('trimKey');
    const queryTransmissionKey = query.get('transmissionKey');
    const isTemporaryBuild = query.get('isTemporaryBuild') === 'true';
    const buildId = query.get('buildId');
    // in ExperienceEditor and Preview, as well as BAP model page, do not redirect
    const isPageEditing = usePageEditing();
    const isPagePreview = usePageState() === 'preview';
    if (isPageEditing || isPagePreview || pathname === baseUrl) {
        return {
            buildId,
            shouldRedirect: false,
        };
    }
    if (isTemporaryBuild) {
        return {
            buildId,
            shouldRedirect: false,
            shouldUpdateTemporaryBuild: true,
            redirectUrl: appendQueryString(`${baseUrl}/summary`, new URLSearchParams(transformedData)),
        };
    }
    // redirect user after loading details from buildId
    if (redirectToSummary) {
        return {
            buildId,
            shouldRedirect: true,
            redirectUrl: appendQueryString(`${baseUrl}/summary`, new URLSearchParams(transformedData)),
        };
    }
    // layout api triggers an error state if model year is invalid
    const erroredByModelYear = layoutHasError && !(transmissions === null || transmissions === void 0 ? void 0 : transmissions.some(transmission => (transmission === null || transmission === void 0 ? void 0 : transmission.modelYear) === queryModelYear));
    // layout is skipped entirely if model key is invalid, but some components on BAP don't get
    // their models from sitecore fields, so we also check if the api is initially triggered
    // to guard against false positives
    const erroredByInvalidModelKey = !layoutIsTriggered &&
        layoutIsSkipped &&
        !(transmissions === null || transmissions === void 0 ? void 0 : transmissions.some(transmission => (transmission === null || transmission === void 0 ? void 0 : transmission.modelKey) === queryModelKey));
    if (erroredByModelYear || erroredByInvalidModelKey) {
        return {
            buildId,
            shouldRedirect: true,
            redirectUrl: baseUrl,
        };
    }
    // we will still get vehicles if there is a valid model key or year, therefore we check the tranmissions array itself
    if (layoutIsTriggered &&
        backStepUrl.href &&
        (transmissions === null || transmissions === void 0 ? void 0 : transmissions.length) &&
        (!(transmissions === null || transmissions === void 0 ? void 0 : transmissions.some(transmission => (transmission === null || transmission === void 0 ? void 0 : transmission.trimKey) === queryTrimKey)) ||
            !(transmissions === null || transmissions === void 0 ? void 0 : transmissions.some(transmission => (transmission === null || transmission === void 0 ? void 0 : transmission.transmissionKey) === queryTransmissionKey)))) {
        return {
            buildId,
            shouldRedirect: true,
            redirectUrl: appendQueryString(backStepUrl.href, query, modelQueryParams),
        };
    }
    return {
        buildId,
        shouldRedirect: false,
    };
};
export default useBapParamsValidation;
